<template>
  <div>
    <el-input v-model="value[name]" style="width: 80%; max-width: 680px; margin-bottom: 1em">
      <div slot="prepend" style="width: auto; min-width: 100px">
        {{ setting.label || name }}
        <Tooltip :label="setting.label || name" :content="setting.detail" />
      </div>
    </el-input>
    <el-color-picker v-model="value[name]" style="position: relative; vertical-align: top" />
  </div>
</template>

<script>
/**
 * Color SmartField - Renders a color picker for color configuration values.
 *
 * @component
 * @description Displays a text input showing the hex color value alongside a color picker button.
 * The user can either type the hex value directly or use the color picker to select a color visually.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the color picker (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {string} [setting.default] - Default hex color value if not set (e.g., '#FF0000')
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Color
 *   :value="config"
 *   :setting="{ label: 'Theme Color', detail: 'Select theme color', default: '#1890ff' }"
 *   name="themeColor"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
